import { render, staticRenderFns } from "./data-import-status.vue?vue&type=template&id=51789bb0&scoped=true&"
import script from "./data-import-status.vue?vue&type=script&lang=ts&"
export * from "./data-import-status.vue?vue&type=script&lang=ts&"
import style0 from "./data-import-status.vue?vue&type=style&index=0&id=51789bb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51789bb0",
  null
  
)

export default component.exports